// containers
export const mainDivId = "store_locator_425";
export const mapDivId = "store_locator_map_426";

// urls
export const mapStylesUrl = "https://static.progusmaps.com/styles/";

export const API_URL = "https://sl-front.proguscommerce.com/api/";
//export const API_URL = "https://test-mateusz-front.proguscommerce.com/api/"; //test
// export const API_URL = "https://test-api-01.proguscommerce.com/api/";
// export const API_URL = "https://test-api-front.proguscommerce.com/api/";
export const CSS_URL = "https://sl.proguscommerce.com/main.css";
//export const CSS_URL = "https://test-mateusz.proguscommerce.com/api/front/css"; //test
// export const CSS_URL = "https://test-api-01.proguscommerce.com/api/front/css";

